import { TopicIcon } from '../../courses/OutlineNode';
import { CourseIcon } from '../../courses/PreviewNavList';

// Flat nav (course row + every topic, no expand/collapse) - same simplified
// shape english-app's own CourseOutline.tsx already uses as its port of
// this exact CRM pattern (PreviewNavList.jsx). Topics come pre-fetched from
// useStudentWorkspaceData (no separate fetch here) since
// StudentWorkspaceView always renders every topic's activity in one
// continuous scroll - unlike the admin constructor, there's no separate
// "select to filter" concept here, this list is purely a jump-to-topic +
// "where am I" indicator.
export default function WorkspaceOutline({ course, topics, activeTopicId, onJumpToCourse, onJumpToTopic }) {
   return (
      <div className='course-tree-flat-list'>
         <div className={'course-tree-row course-tree-row-course' + (!activeTopicId ? ' selected' : '')}
            onClick={onJumpToCourse}>
            <span className='course-tree-topic-icon' title='Курс'><CourseIcon /></span>
            <span className='course-tree-node-label'>{course ? course.name : 'Курс'}</span>
         </div>
         {topics.length === 0 ? (
            <div className='course-tree-flat-empty'>У цьому курсі ще немає тем.</div>
         ) : topics.map(({ topic }) => (
            <div key={'topic-' + topic.id}
               className={'course-tree-row course-tree-row-topic' + (activeTopicId === topic.id ? ' in-view' : '')}
               onClick={() => onJumpToTopic(topic.id)}>
               {activeTopicId === topic.id ? <span className='course-tree-in-view-dot' /> : ''}
               <span className='course-tree-topic-icon' title='Тема'><TopicIcon /></span>
               <span className='course-tree-node-label'>{topic.name}</span>
            </div>
         ))}
      </div>
   );
}
